import tw, { styled } from 'twin.macro';

export const BgColor = styled.span`
    && {
        ${({ color, light, dark }) => [
            color === 'primary' && tw`bg-primary text-primary-contrast`,
            color === 'primary' && (light ? tw`bg-primary-light` : dark && tw`bg-primary-dark`),
            color === 'secondary' && tw`bg-secondary text-secondary-contrast`,
            color === 'secondary' && (light ? tw`bg-secondary-light` : dark && tw`bg-secondary-dark`),
            color === 'error' && tw`bg-error text-error-contrast`,
            color === 'error' && (light ? tw`bg-error-light` : dark && tw`bg-error-dark`),
            color === 'warning' && tw`bg-warning text-warning-contrast`,
            color === 'warning' && (light ? tw`bg-warning-light` : dark && tw`bg-warning-dark`),
            color === 'info' && tw`bg-info text-info-contrast`,
            color === 'info' && (light ? tw`bg-info-light` : dark && tw`bg-info-dark`),
            color === 'success' && tw`bg-success text-success-contrast`,
            color === 'success' && (light ? tw`bg-success-light` : dark && tw`bg-success-dark`),
            color === 'delete' && tw`bg-delete text-delete-contrast`,
            color === 'delete' && (light ? tw`bg-delete-light` : dark && tw`bg-delete-dark`),
            color === 'card' && tw`bg-card text-color-normal`,
            color === 'paper' && tw`bg-paper text-color-normal`,
        ]}
    }
`;

export const BgColorHover = styled(BgColor)`
    && {
        ${({ color, light, dark }) => [
            color === 'primary' && (light ? tw`hover:bg-primary` : (dark ? tw`hover:bg-primary-900` : tw`hover:bg-primary-dark`)),
            color === 'secondary' && (light ? tw`hover:bg-secondary` : (dark ? tw`hover:bg-secondary-900` : tw`hover:bg-secondary-dark`)),
            color === 'error' && (light ? tw`hover:bg-error` : (dark ? tw`hover:bg-error-900` : tw`hover:bg-error-dark`)),
            color === 'warning' && (light ? tw`hover:bg-warning` : (dark ? tw`hover:bg-warning-900` : tw`hover:bg-warning-dark`)),
            color === 'info' && (light ? tw`hover:bg-info` : (dark ? tw`hover:bg-info-900` : tw`hover:bg-info-dark`)),
            color === 'success' && (light ? tw`hover:bg-success` : (dark ? tw`hover:bg-success-900` : tw`hover:bg-success-dark`)),
            color === 'delete' && (light ? tw`hover:bg-delete` : (dark ? tw`hover:bg-delete-900` : tw`hover:bg-delete-dark`)),
        ]}
    }
`;

export default BgColor;